import clsx from 'clsx';

// `import.meta.glob` нь зургийн файл байхгүй үед `{}` буцаах учир compile
// алдаа гарахгүй — хэрэглэгч `src/assets/brand/logo-{icon,full}.png`-ыг
// commit хийсний дараа автомат resolve хийгдэнэ.
const ICONS = import.meta.glob('@/assets/brand/logo-icon.*', {
  eager: true,
  query: '?url',
  import: 'default',
}) as Record<string, string>;

const FULL = import.meta.glob('@/assets/brand/logo-full.*', {
  eager: true,
  query: '?url',
  import: 'default',
}) as Record<string, string>;

function firstUrl(map: Record<string, string>): string | null {
  const keys = Object.keys(map);
  return keys.length > 0 ? (map[keys[0]!] ?? null) : null;
}

interface Props {
  /** `icon` = sidebar дотор (tree+cube square mark).
   *  `full` = login + landing hero (text-тэй portrait logo). */
  variant?: 'icon' | 'full';
  /** Зурагдсан хэмжээ (px эсвэл CSS unit). Default-аар variant-р тогтоогдоно. */
  size?: number | string;
  className?: string;
  /** Зураг ачаалаагүй / commit хийгээгүй үед харагдах fallback. Default-аар
   *  icon variant нь "T" mark text, full variant нь "TseTsu" wordmark. */
  fallback?: React.ReactNode;
  alt?: string;
}

/**
 * Brand зургийг render хийнэ. `src/assets/brand/`-аас файлын тогтоосон
 * pattern-аар автомат олно. Файл байхгүй үед текст fallback (Phase 5
 * шилжилтийн үеэр зураг суух хүртэл-ыг хамгаалах).
 */
export function BrandLogo({
  variant = 'icon',
  size,
  className,
  fallback,
  alt = 'TseTsu SAAS ERP',
}: Props) {
  const url = variant === 'icon' ? firstUrl(ICONS) : firstUrl(FULL);

  if (url) {
    const dim = size ?? (variant === 'icon' ? 36 : 240);
    return (
      <img
        src={url}
        alt={alt}
        className={clsx('ts-brand-logo', `ts-brand-logo-${variant}`, className)}
        style={{ width: dim, height: 'auto', display: 'block' }}
      />
    );
  }

  // Fallback (зураг commit хийгдээгүй үе)
  if (fallback !== undefined) return <>{fallback}</>;
  if (variant === 'icon') {
    return <div className={clsx('ts-brand-icon', className)}>T</div>;
  }
  return (
    <div className={clsx('ts-brand-wordmark', className)}>
      Tse<span>Tsu</span>
    </div>
  );
}
